export default __webpack_public_path__ + "static/media/email.411084f3.svg";